import React, { useEffect, useRef, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../../components/layout/Footer/Footer";
import {
  selectReviews,
  selectLoading,
  selectError,
  fetchReviews,
} from "../../store/slices/reviewsSlice";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { Span1 } from "../ServicePages/Services1/styles";
import { H1, Tags2 } from "../About/PostDetail/styles";
import Controlledtext from "../../components/ControlledText/Controlledtext";
import ControlledtextMobile from "../../components/ControlledTextMobile/ControlledTextMobile.tsx";
import {
  Btnratings,
  Div,
  PartFlex,
  Popup,
  Popup2,
  PopupInner,
  ReviewsContainer,
  Tag3,
  Xratings,
} from "./styles";
import { RootState } from "../../store";
import { Tag1, Tag2 } from "../About/Blog/styles";
import {
  Part1,
  Part1Text1,
  Part1Text1Title,
  Part1Text2,
  Part2,
  Part2Text1,
  Part2Text2,
  RatingItem,
  RatingItem2,
  RatingTextContainer,
} from "../../components/Ratings/styles";
import { fetchCategories } from "../../store/slices/сategoriesSlice";
import { ReviewComponent } from "./CategoriesComponent";

const Ratings: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const reviews = useSelector(selectReviews);
  const loading = useSelector(selectLoading);
  const error = useSelector(selectError);
  const categories = useSelector(
    (state: RootState) => state.categories.categories
  );

  // console.log('categories: ', categories)

  const tagsRef = useRef<HTMLDivElement | null>(null);
  const popupRef = useRef<HTMLDivElement | null>(null);

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedReview, setSelectedReview] = useState<any | null>(null);

  // Обработчик прокрутки тегов
  useEffect(() => {
    if (tagsRef.current) {
      const handleWheel = (evt: WheelEvent) => {
        evt.preventDefault();
        tagsRef.current!.scrollLeft += evt.deltaY;
      };

      tagsRef.current.addEventListener("wheel", handleWheel);
      return () => tagsRef.current!.removeEventListener("wheel", handleWheel);
    }
  }, []);

  useEffect(() => {
    dispatch(fetchReviews());
    dispatch(fetchCategories());
  }, [dispatch]);

  const handleCategoryClick = (id: number | null) => {
    setSelectedCategoryId(id);
  };

  const handleRatingItemClick = (review: any) => {
    setSelectedReview(review);
    if (popupRef.current) popupRef.current.style.display = "block";
  };

  const hidePopup = () => {
    if (popupRef.current) popupRef.current.style.display = "none";
    setSelectedReview(null);
  };

  const filteredReviews = useMemo(() => {
    return reviews.filter((review) =>
      selectedCategoryId === null
        ? true
        : review.product?.product_category === selectedCategoryId
    );
  }, [reviews, selectedCategoryId]);

  if (loading) return <div>Загрузка...</div>;
  if (error) return <div>Ошибка: {error}</div>;
  if (!Array.isArray(categories) || categories.length === 0)
    return <div>Нет доступных категорий.</div>;

  return (
    <>
      <H1>Отзывы</H1>

      <Tags2 ref={tagsRef}>
        <Tag1
          onClick={() => handleCategoryClick(null)}
          isActive={selectedCategoryId === null}
        >
          Все
        </Tag1>
        {categories.map((category) => (
          <Tag2
            key={category.id}
            onClick={() => handleCategoryClick(category.id)}
            isActive={selectedCategoryId === category.id}
          >
            {category.title}
          </Tag2>
        ))}
      </Tags2>

      {filteredReviews.length > 0 ? (
        <ReviewsContainer>
          {filteredReviews.map((review) => (
            <RatingItem
              key={review.id}
              $img={require("./item6.png")}
              onClick={() => handleRatingItemClick(review)}
            >
              {review.product?.product_category != null && (
                <Div>
                  <Tag3>
                    <ReviewComponent review={review.product} />
                  </Tag3>
                </Div>
              )}
              <RatingTextContainer>
                <Part1>
                  <Part1Text1Title>
                    {review.product?.title || `Отзыв №${review.id}`}
                  </Part1Text1Title>
                  <Controlledtext
                    text={review.content || null}
                    maxLength={350}
                  />
                  <ControlledtextMobile
                    text={review.content || null}
                    maxLength={300}
                  />
                </Part1>
                <Part2>
                  <Part2Text1>
                    <Span1>{review.author || null},</Span1>{" "}
                    {review.job_title || null}
                  </Part2Text1>
                  <Part2Text2 href={review.profile_url || "#"}>
                    Профиль LinkedIn →
                  </Part2Text2>
                </Part2>
              </RatingTextContainer>
            </RatingItem>
          ))}
        </ReviewsContainer>
      ) : (
        <H1>Отзывов нет</H1>
      )}

      <Popup ref={popupRef}>
        <Popup2>
          <PopupInner>
            <Xratings onClick={hidePopup} $img={require("../Main/X.jpg")} />
            {selectedReview && (
              <>
                <Part1Text1>
                  {selectedReview.product?.title || "Отзыв"}
                </Part1Text1>
                <Part1Text2>
                  {selectedReview.content || "Нет содержания"}
                </Part1Text2>
                <PartFlex>
                  <Span1>{selectedReview.author || ""}</Span1>
                  {selectedReview.job_title || ""}
                  <Part2Text2 href={selectedReview.profile_url || "#"}>
                    Профиль LinkedIn →
                  </Part2Text2>
                </PartFlex>
              </>
            )}
          </PopupInner>
        </Popup2>
      </Popup>

      <Btnratings onClick={() => alert("Это все отзывы!")}>
        Показать ещё
      </Btnratings>
      <Footer />
    </>
  );
};

export default Ratings;
